import script from "./loans-savings-report.vue?vue&type=script&setup=true&lang=js"
export * from "./loans-savings-report.vue?vue&type=script&setup=true&lang=js"

import "./loans-savings-report.vue?vue&type=style&index=0&id=51bbe247&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51bbe247"]])

export default __exports__